import React from 'react';
import 'moment-timezone';
import {Table, TableBody, TableCell, TableHead, TableRow, withStyles} from "@material-ui/core";
import styles from './styles';
import moment from "moment/moment";

const InsuranceCoverage = (props) => {
        const { coverage, classes } = props
        const receivedDate = coverage?.shipmentDate ? moment(coverage?.shipmentDate).format('MM/DD/YYYY  hh:mm a') : '';

        return (
            <Table className={classes.table}>
                <TableHead className={classes.tHead}>
                    <TableRow>
                        <TableCell className={classes.tableHeaderCell} >Received Date</TableCell>
                        <TableCell className={classes.tableHeaderCell} >Shipment ID</TableCell>
                        <TableCell className={classes.tableHeaderCell} >Commodity Type</TableCell>
                        <TableCell className={classes.tableHeaderCell} >Retail Value</TableCell>
                        <TableCell className={classes.tableHeaderCell} >Customer Name</TableCell>
                        <TableCell className={classes.tableHeaderCell} >Customer Address</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { coverage?.shipmentId ?
                    <TableRow className={classes.tableRow} key={coverage?.shipmentId || 'row'}>
                        <TableCell className={classes.tableCell}>{receivedDate}</TableCell>
                        <TableCell>{coverage?.shipmentId || ''}</TableCell>
                        <TableCell>{coverage?.commodityType}</TableCell>
                        <TableCell>{coverage?.merchandiseValue}</TableCell>
                        <TableCell>{coverage?.customerName}</TableCell>
                        <TableCell>{coverage?.customerAddress}</TableCell>
                    </TableRow> :
                    <TableRow>
                        <TableCell colSpan={6} className={classes.noData}>&nbsp;</TableCell>
                    </TableRow>
                    }
                </TableBody>
            </Table>
        )

}
export default withStyles(styles)(InsuranceCoverage);
